const clickOriginalVideoCommand = (popup, editor, cmd, param) => {
  const selector = param
    ? `.teo-video-original-buttons .fr-command[data-cmd="${cmd}"][data-param1="${param}"]`
    : `.teo-video-original-buttons .fr-command[data-cmd="${cmd}"]`;

  const original = popup.querySelector(selector);

  if (original) {
    original.dispatchEvent(
      new MouseEvent('mousedown', {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
    original.dispatchEvent(
      new MouseEvent('mouseup', {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
    original.dispatchEvent(
      new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
    );
    return true;
  }

  editor.selection?.restore?.();

  if (param !== undefined) editor.commands.exec(cmd, param);
  else editor.commands.exec(cmd);

  return true;
};

const updateVideoSubmenuActiveState = (editor, popup) => {
  const $video = editor?.video?.get?.();
  if (!$video?.length) return;

  const video = $video.get(0);
  const target = video.closest?.('.fr-video') || video;
  const style = window.getComputedStyle(target);

  const display = style.display;
  const floatValue = style.float;
  const textAlign = style.textAlign;
  const marginLeft = style.marginLeft;
  const marginRight = style.marginRight;

  let activeAlign = '';

  if (floatValue === 'left' || textAlign === 'left') {
    activeAlign = 'left';
  } else if (floatValue === 'right' || textAlign === 'right') {
    activeAlign = 'right';
  } else if (
    textAlign === 'center' ||
    (display === 'block' && marginLeft === 'auto' && marginRight === 'auto')
  ) {
    activeAlign = 'center';
  }

  let activeDisplay = '';

  if (floatValue === 'left' || floatValue === 'right') {
    activeDisplay = 'inline';
  } else if (display === 'inline' || display === 'inline-block') {
    activeDisplay = 'inline';
  } else if (display === 'block') {
    activeDisplay = 'block';
  }

  popup.querySelectorAll('[data-teo-video-param]').forEach((btn) => {
    const cmd = btn.getAttribute('data-teo-video-cmd');
    const param = btn.getAttribute('data-teo-video-param');

    btn.classList.remove('teo-video-settings-item_active');
    btn.querySelector('.teo-active-check')?.remove();

    const isActive =
      (cmd === 'videoAlign' && param === activeAlign) ||
      (cmd === 'videoDisplay' && param === activeDisplay);

    if (isActive) {
      btn.classList.add('teo-video-settings-item_active');
      btn.insertAdjacentHTML(
        'beforeend',
        `
                <span class="teo-active-check ml-auto">
                    <i class="far fa-check ml-auto text-[17px]"></i>
                </span>
                `
      );
    }
  });
};

const positionPopupAtTargetTopLeft = (popup, target) => {
  if (!popup || !target) return;

  const rect = target.getBoundingClientRect();

  popup.style.setProperty('position', 'absolute', 'important');
  popup.style.setProperty(
    'left',
    `${rect.left + window.scrollX}px`,
    'important'
  );
  popup.style.setProperty('top', `${rect.top + window.scrollY}px`, 'important');
  popup.style.setProperty('transform', 'none', 'important');
};

export const updateVideoPopupDesign = (editor) => {
  const t = window.i18n.t;
  const popup = editor?.popups?.get?.('video.edit')?.get?.(0);

  if (!popup) return;

  const $video = editor?.video?.get?.();
  const video = $video?.length ? $video.get(0) : null;
  const target = video?.closest?.('.fr-video') || video;
  positionPopupAtTargetTopLeft(popup, target);

  if (popup.dataset.teoVideoPopupReady === 'true') {
    updateVideoSubmenuActiveState(editor, popup);
    return;
  }

  popup.dataset.teoVideoPopupReady = 'true';
  popup.classList.add('teo-video-popup');

  const videoMenuItems = [
    {
      label: t('widgets.toolbar_button.video_settings.replace_video'),
      icon: '<i class="far fa-exchange-alt text-[17px]"></i>',
      cmd: 'videoReplace',
    },
    {
      label: t('widgets.toolbar_button.video_settings.video_alignment'),
      icon: '<i class="far fa-align-left text-[17px]"></i>',
      cmd: 'videoAlign',
      arrow: true,
    },
    {
      label: t('widgets.toolbar_button.video_settings.text_wrapping'),
      icon: '<i class="far fa-indent text-[17px]"></i>',
      cmd: 'videoDisplay',
      arrow: true,
    },
    {
      label: t('widgets.toolbar_button.video_settings.subtitles'),
      icon: '<img src="/images/icons/video_caption.svg" class="!w-5" />',
      cmd: 'generateSubtitles',
    },
    {
      label: t('widgets.toolbar_button.video_settings.resize'),
      icon: '<i class="far fa-expand-alt text-[17px]"></i>',
      cmd: 'videoSize',
      arrow: true,
    },
    {
      label: t('widgets.toolbar_button.video_settings.video_playback'),
      icon: '<i class="fas fa-play text-[17px]"></i>',
      cmd: 'autoplay',
      arrow: true,
    },
    {
      label: t('widgets.toolbar_button.video_settings.delete_video'),
      icon: '<img src="/images/icons/trash_icon_red.svg" class="!w-4" />',
      cmd: 'videoRemove',
      danger: true,
    },
  ];

  const submenus = {
    videoAlign: [
      {
        icon: '<i class="far fa-align-left text-[17px]"></i>',
        label: t('widgets.toolbar_button.left_align'),
        param: 'left',
      },
      {
        icon: '<i class="far fa-align-right text-[17px]"></i>',
        label: t('widgets.toolbar_button.right_align'),
        param: 'right',
      },
      {
        icon: '<i class="far fa-align-center text-[17px]"></i>',
        label: t('widgets.toolbar_button.middle_align'),
        param: 'center',
      },
    ],
    videoDisplay: [
      {
        label: t('widgets.toolbar_button.image_settings.inline'),
        icon: '<i class="far fa-indent text-[17px]"></i>',
        param: 'inline',
      },
      {
        label: t('widgets.toolbar_button.image_settings.break_text'),
        icon: '<img src="/images/icons/insert_media.svg" class="!w-5" />',
        param: 'block',
      },
    ],
  };

  const buttons = popup.querySelector('.fr-buttons');
  if (!buttons) return;

  const oldButtonsHtml = buttons.innerHTML;

  buttons.innerHTML = `
    <div class="teo-video-settings-menu">
      ${videoMenuItems
        .map((item) => {
          const submenu = submenus[item.cmd];

          return `
            <div class="teo-video-settings-row">
              <button
                type="button"
                class="teo-video-settings-item ${
                  item.danger ? 'teo-video-settings-item_danger' : ''
                }"
                data-teo-video-cmd="${item.cmd}"
              >
                <span class="teo-video-settings-icon">${item.icon}</span>
                <span class="teo-video-settings-label">${item.label}</span>
                ${
                  item.arrow
                    ? '<i class="far fa-chevron-right text-grey-03 ml-auto"></i>'
                    : ''
                }
              </button>

              ${
                submenu
                  ? `
                    <div class="teo-video-submenu-inline">
                      <div class="teo-video-submenu-list">
                        ${submenu
                          .map(
                            (sub) => `
                              <button
                                type="button"
                                class="teo-video-settings-item"
                                data-teo-video-cmd="${item.cmd}"
                                data-teo-video-param="${sub.param}"
                              >
                                <span class="teo-video-submenu-icon">${sub.icon}</span>
                                <span class="teo-video-submenu-label">${sub.label}</span>
                              </button>
                            `
                          )
                          .join('')}
                      </div>
                    </div>
                  `
                  : ''
              }
            </div>
          `;
        })
        .join('')}
    </div>

    <div class="teo-video-original-buttons" style="display:none;">
      ${oldButtonsHtml}
    </div>
  `;

  updateVideoSubmenuActiveState(editor, popup);

  popup.querySelectorAll('[data-teo-video-cmd]').forEach((btn) => {
    btn.addEventListener('mousedown', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const cmd = btn.getAttribute('data-teo-video-cmd');
      const param = btn.getAttribute('data-teo-video-param');

      if (!cmd) return;
      if (submenus[cmd] && !param) return;

      clickOriginalVideoCommand(popup, editor, cmd, param || undefined);

      setTimeout(() => {
        updateVideoSubmenuActiveState(editor, popup);
        editor.popups.hide('video.edit');
      }, 0);
    });
  });
};
